enum SetActions {
    SetResultsPerPage = 'pagination/results/SET',
}

export const PaginationActionTypes = {
    ...SetActions,
};
